import { Injectable } from '@angular/core';
import { Question } from '.';
import { TextboxQuestion, CheckboxQuestion, QuestionBase, HiddenQuestion, QuestionGroup } from 'core/components/forms';

@Injectable()
export class QuestionsQuestionsService {
  getQuestions(question: Question, documentId, clientId) {
    const answers = [];
    let questionAnswers = question && question.answers;
    // By default we will allow to set 4 answers for the question
    if (!questionAnswers || !questionAnswers.length) {
      questionAnswers = [
        {
          key: 'answer1',
          label: 'nouns.answer',
          class: 'col s10',
          order: 41,
          validators: { required: true }
        },
        {
          key: 'answer2',
          label: 'nouns.answer',
          class: 'col s10',
          order: 42,
          validators: { required: true }
        },
        {
          key: 'answer3',
          label: 'nouns.answer',
          class: 'col s10',
          order: 43,
          validators: { required: true }
        },
        { key: 'answer4', label: 'nouns.answer', class: 'col s10', order: 44 }
      ];
    }
    questionAnswers.forEach((answer, answerIndex) => {
      // The text
      answers.push(
        new TextboxQuestion({
          key: `answer${answerIndex + 1}`,
          label: 'nouns.answer',
          class: 'col s10',
          order: 4 + answerIndex,
          validators: { required: answerIndex < 3 ? true : false },
          value: (answer && answer.title) || null
        })
      );

      // the correctness
      answers.push(
        new CheckboxQuestion({
          key: `isCorrect${answerIndex + 1}`,
          label: 'nouns.isCorrect',
          class: 'col s2',
          value: answer && answer.isCorrect,
          order: 5 + answerIndex
        })
      );
    });

    const questions: QuestionBase<any>[] = [
      new HiddenQuestion({
        key: 'documentId',
        value: documentId,
        validators: { required: true },
        order: 1
      }),
      new HiddenQuestion({
        key: 'clientId',
        value: clientId,
        validators: { required: false },
        order: 2
      }),
      new TextboxQuestion({
        key: 'question',
        label: 'customizations.documents.questions.text',
        value: question && question.question ? question.question : null,
        validators: { required: true },
        controlType: 'hidden',
        order: 3,
        eventHandlers: {}
      }),
      new QuestionGroup({
        order: 4,
        class: 'col s12',
        childQuestions: answers
      })
    ];

    return questions.sort((a, b) => a.order - b.order);
  }
}
